import { translate, plainText } from '../../../ContentTranslation';
import React, { useEffect, useId, useRef, useState } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../../StableImage';
import Library from '../../../scene/utility/Library';
import tooltipEffect from '../../../scene/utility/tooltipEffect';

export default function RunItemIcon({ type, itemKey, power = 1 }) {
  const id = 'run-item-' + useId().replace(/:/g, '');
  const [open, setOpen] = useState(false);
  const pointerType = useRef(null);
  const companion = type === 'companion';
  const item = companion ? Library.getCompanion(itemKey) : Library.getRelic(itemKey);
  const model = item && (companion ? item : Library.upgradeItem(item, power));

  useEffect(() => {
    if (!open) return;
    const dismiss = event => {
      if (event.target !== document.getElementById(id)) setOpen(false);
    };
    const escape = event => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', dismiss, true);
    document.addEventListener('keydown', escape);
    return () => {
      document.removeEventListener('pointerdown', dismiss, true);
      document.removeEventListener('keydown', escape);
    };
  }, [open, id]);

  if (!model) return null;

  return <>
    <Img id={id} className="progress-run-item" src={model.img} alt={model.name}
      role="button" tabIndex={0} aria-expanded={open}
      onPointerEnter={event => { if (event.pointerType === 'mouse') setOpen(true); }}
      onPointerLeave={event => { if (event.pointerType === 'mouse') setOpen(false); }}
      onPointerDown={event => { pointerType.current = event.pointerType; event.stopPropagation(); }}
      onClick={event => {
        event.stopPropagation();
        if (pointerType.current !== 'mouse') setOpen(value => !value);
      }}
      onFocus={() => { if (!pointerType.current) setOpen(true); }}
      onBlur={() => { setOpen(false); pointerType.current = null; }}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          setOpen(value => !value);
        }
      }}
    />
    {open && <Tooltip className={'tooltip' + (companion ? ' companion-tooltip' : '')}
      placement="bottom" target={id} isOpen trigger="manual" onClick={event => event.stopPropagation()}>
      <b><img alt="" src={'/images/' + type + '.png'}/>{model.name}</b><br/>
      {companion ? <>
        <span className="shop-companion-skill"><b>{translate("Skill:")}</b>&nbsp;{plainText(model.skill.effect)}</span><br/>
        <span className="shop-companion-auto"><b>{translate("Action:")}</b>&nbsp;{plainText(model.action.effect)}</span>
      </> : tooltipEffect(model.effect)}
    </Tooltip>}
  </>;
}
